import * as RadioGroup from "@radix-ui/react-radio-group";
import { type ReactNode } from "react";

interface RadioRootProps extends RadioGroup.RadioGroupProps {
  children: ReactNode;
}

interface RadioItemProps extends RadioGroup.RadioGroupItemProps {
  children: ReactNode;
}

interface RadioLabelProps {
  htmlFor: string;
  children: ReactNode;
}

const RadioRoot = ({ children, ...props }: RadioRootProps) => {
  return <RadioGroup.Root {...props}>{children}</RadioGroup.Root>;
};

RadioRoot.displayName = "Radio.Root";

const RadioItem = ({ children, ...props }: RadioItemProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="w-5 h-5 me-1">
        <RadioGroup.Item
          {...props}
          className="w-5 h-5 border-1 rounded-full border-primary-light focus:border-primary-light flex-grow-1"
        >
          <RadioGroup.Indicator className="relative flex items-center justify-center w-full h-full rounded-full after:content after:block after:w-full after:h-full after:bg-primary-light after:rounded-full" />
        </RadioGroup.Item>
      </div>
      {children}
    </div>
  );
};

RadioItem.displayName = "Radio.Item";

const RadioLabel = ({ htmlFor, children }: RadioLabelProps) => {
  return <label htmlFor={htmlFor} className="text-sm">{children}</label>;
};

RadioLabel.displayName = "Radio.Label";

export const Radio = {
  Root: RadioRoot,
  Item: RadioItem,
  Label: RadioLabel,
};
